<template>
  <div class="amz-page">
    <!-- Header -->
    <div class="amz-header">
      <div>
        <span class="header-eyebrow">Amazon</span>
        <h2 class="header-title">SKU Amazon</h2>
      </div>
      <div class="header-actions">
        <button class="btn-amz btn-amz--primary" @click="showForm = !showForm">
          <i :class="showForm ? 'fa-solid fa-xmark' : 'fa-solid fa-plus'"></i>
          {{ showForm ? 'Cerrar' : 'Nuevo registro' }}
        </button>
      </div>
    </div>

    <!-- KPI Strip -->
    <div class="kpi-strip">
      <div class="kpi-card">
        <span class="kpi-label">Registros</span>
        <span class="kpi-value">{{ records.length }}</span>
        <span class="kpi-foot">total</span>
      </div>
      <div class="kpi-card">
        <span class="kpi-label">Mostrando</span>
        <span class="kpi-value">{{ filteredRecords.length }}</span>
        <span class="kpi-foot">resultados</span>
      </div>
    </div>

    <!-- Form -->
    <transition name="slide">
      <div class="form-card" v-if="showForm">
        <div class="form-card__header">
          <div class="form-card__icon">
            <i class="fa-solid fa-plus"></i>
          </div>
          <div>
            <h3 class="form-card__title">Nuevo registro SKU Amazon</h3>
          </div>
        </div>

        <div class="form-grid">
          <div class="field">
            <label class="field__label">SKU Amazon</label>
            <b-form-input size="sm" v-model="form.skuAmazon" placeholder="SKU de Amazon" class="field__input" />
          </div>
          <div class="field">
            <label class="field__label">EAN Amazon</label>
            <b-form-input size="sm" v-model="form.eanAmazon" placeholder="EAN de Amazon" class="field__input" />
          </div>
          <div class="field">
            <label class="field__label">SKU Real</label>
            <b-form-input size="sm" v-model="form.skuReal" placeholder="SKU interno" class="field__input" />
          </div>
          <div class="field">
            <label class="field__label">EAN Disponible</label>
            <b-form-input size="sm" v-model="form.eanDisponible" placeholder="EAN disponible" class="field__input" />
          </div>
        </div>

        <div class="form-card__footer">
          <button class="btn-amz btn-amz--ghost" @click="showForm = false">Cancelar</button>
          <button class="btn-amz btn-amz--primary" @click="saveNewLine()">
            <i class="fa-solid fa-plus"></i> Crear registro
          </button>
        </div>
      </div>
    </transition>

    <!-- Table -->
    <div class="list-card">
      <div class="list-card__header">
        <h3 class="list-card__title">Registros</h3>
        <div class="search-box">
          <i class="fa-solid fa-magnifying-glass search-box__icon"></i>
          <input type="text" class="search-box__input" placeholder="Buscar SKU, EAN..." v-model="searchTerm" />
        </div>
      </div>

      <div class="table-wrapper">
        <b-table
          :items="filteredRecords"
          :fields="columns"
          class="mb-0"
          hover
          sort-icon-left
          responsive
          show-empty
          empty-text="Sin registros"
          thead-class="table-head"
          tbody-tr-class="table-row"
        >
          <template #cell(skuAmazon)="data">
            <span class="cell-sku">{{ data.item.skuAmazon }}</span>
          </template>
          <template #cell(eanAmazon)="data">
            <span class="cell-mono">{{ data.item.eanAmazon }}</span>
          </template>
          <template #cell(skuReal)="data">
            <span class="cell-sku cell-sku--accent">{{ data.item.skuReal }}</span>
          </template>
          <template #cell(eanDisponible)="data">
            <span class="cell-mono" v-if="data.item.eanDisponible">{{ data.item.eanDisponible }}</span>
            <span class="cell-muted" v-else>--</span>
          </template>
          <template #cell(acciones)="data">
            <div class="cell-actions">
              <button class="action-btn action-btn--edit" @click="editLine(data.item)" title="Editar">
                <i class="fa-solid fa-pen"></i>
              </button>
              <button class="action-btn action-btn--delete" @click="deleteLine(data.item)" title="Eliminar">
                <i class="fa-solid fa-trash"></i>
              </button>
            </div>
          </template>
        </b-table>
      </div>

      <div class="list-card__footer">
        <span class="footer-count">{{ filteredRecords.length }} registros</span>
      </div>
    </div>

    <!-- Modal editar -->
    <b-modal
      id="modal-edit-sku"
      modal-class="modal-amz"
      centered
      hide-header
      hide-footer
      size="lg"
    >
      <div class="modal-inner">
        <div class="modal-hdr">
          <div class="modal-hdr__icon"><i class="fa-solid fa-pen"></i></div>
          <h4 class="modal-hdr__title">Editar registro</h4>
          <p class="modal-hdr__sub">{{ titleEdit }}</p>
        </div>

        <div class="modal-body-custom">
          <div class="form-grid">
            <div class="field">
              <label class="field__label">SKU Amazon</label>
              <b-form-input size="sm" v-model="updateForm.skuAmazon" class="field__input" />
            </div>
            <div class="field">
              <label class="field__label">EAN Amazon</label>
              <b-form-input size="sm" v-model="updateForm.eanAmazon" class="field__input" />
            </div>
            <div class="field">
              <label class="field__label">SKU Real</label>
              <b-form-input size="sm" v-model="updateForm.skuReal" class="field__input" />
            </div>
            <div class="field">
              <label class="field__label">EAN Disponible</label>
              <b-form-input size="sm" v-model="updateForm.eanDisponible" class="field__input" />
            </div>
          </div>
        </div>

        <div class="modal-ftr">
          <button class="btn-modal btn-modal--ghost" @click="$bvModal.hide('modal-edit-sku')">Cancelar</button>
          <button class="btn-modal btn-modal--primary" @click="saveEditLine()">
            <i class="fa-solid fa-check"></i> Guardar
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from '@axios'
import BCardCode from "@core/components/b-card-code";
import { BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BTable, BFormFile } from "bootstrap-vue";
import * as XLSX from 'xlsx';

export default {
  components: { BCardCode, BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BTable, BFormFile },
  data() {
    return {
      showForm: false,
      form: { skuAmazon: "", eanAmazon: "", skuReal: "", eanDisponible: "" },
      updateForm: { id: 0, skuAmazon: "", eanAmazon: "", skuReal: "", eanDisponible: "" },
      records: [],
      columns: [
        { key: "skuAmazon", label: "SKU Amazon", sortable: true },
        { key: "eanAmazon", label: "EAN Amazon", sortable: true },
        { key: "skuReal", label: "SKU Real", sortable: true },
        { key: "eanDisponible", label: "EAN Disponible", sortable: true },
        { key: "acciones", label: "", thStyle: { width: "90px" } },
      ],
      csvSkuAmazon: [],
      titleEdit: '',
      searchTerm: "",
    };
  },
  computed: {
    filteredRecords() {
      if (!this.searchTerm) return this.records;
      const term = this.searchTerm.toLowerCase();
      return this.records.filter(item =>
        (item.skuAmazon && item.skuAmazon.toLowerCase().includes(term)) ||
        (item.eanAmazon && item.eanAmazon.toLowerCase().includes(term)) ||
        (item.skuReal && item.skuReal.toLowerCase().includes(term)) ||
        (item.eanDisponible && item.eanDisponible.toLowerCase().includes(term))
      );
    }
  },
  methods: {
    loadItems() {
      axios.get("/articulos/amazon").then(r => r.data).then(res => { this.records = res; })
        .catch(error => { console.error("Error al cargar los articulos:", error); });
    },
    deleteLine(item) {
      this.$swal({
        title: 'Eliminar registro',
        text: item.skuAmazon,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar',
        customClass: { confirmButton: 'btn btn-outline-danger', cancelButton: 'btn btn-primary ml-1' },
        buttonsStyling: false,
      }).then(result => {
        if (result.isConfirmed) {
          axios.delete("/articulos/amazon/" + item.id).then(r => r.data).then(res => {
            this.records = this.records.filter(dat => dat.id !== item.id);
          });
        }
      })
    },
    editLine(item) {
      this.updateForm = JSON.parse(JSON.stringify(item));
      this.titleEdit = item.skuAmazon;
      this.$bvModal.show('modal-edit-sku');
    },
    saveEditLine() {
      this.$bvModal.hide('modal-edit-sku');
      const item = this.records.find(item => item.id === this.updateForm.id);
      if (item) {
        Object.assign(item, JSON.parse(JSON.stringify(this.updateForm)));
        axios.put("/articulos/amazon", item).then(r => r.data).then(res => {
          this.$bvToast.toast('Actualizado correctamente', { title: 'SKU Amazon', variant: 'success', solid: true })
        }).catch(error => {
          console.error("Error al guardar:", error);
          this.$bvToast.toast('Error al guardar', { title: 'SKU Amazon', variant: 'danger', solid: true })
        });
      }
    },
    saveNewLine() {
      let item = { skuAmazon: this.form.skuAmazon, eanAmazon: this.form.eanAmazon, skuReal: this.form.skuReal, eanDisponible: this.form.eanDisponible, id: 0 }
      axios.post("/articulos/amazon", item).then(r => r.data).then(res => {
        item.id = res.insertId;
        this.records.unshift(item);
        this.$bvToast.toast('Agregado correctamente', { title: 'SKU Amazon', variant: 'success', solid: true })
        this.form = { skuAmazon: "", eanAmazon: "", skuReal: "", eanDisponible: "" };
        this.showForm = false;
      }).catch(error => {
        console.error("Error al crear:", error);
        this.$bvToast.toast('Error al guardar', { title: 'SKU Amazon', variant: 'danger', solid: true })
      });
    }
  },
  mounted() { this.loadItems(); },
};
</script>

<style lang="scss" scoped>
$primary: #3B82F6;
$primary-dark: #2563EB;
$success: #10B981;
$danger: #EF4444;
$warning: #F59E0B;
$border: #E2E8F0;
$text: #1E293B;
$text-muted: #64748B;
$bg: #F8FAFC;
$card-bg: #FFFFFF;
$radius: 12px;
$radius-sm: 8px;
$shadow: 0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04);

.amz-page { max-width: 1200px; margin: 0 auto; padding: 0 8px; }

.amz-header { display: flex; justify-content: space-between; align-items: flex-end; margin-bottom: 20px; }
.header-eyebrow { display: block; font-family: 'JetBrains Mono', monospace; font-size: 11px; font-weight: 600; letter-spacing: 1.5px; text-transform: uppercase; color: #FF9900; margin-bottom: 2px; }
.header-title { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 24px; font-weight: 700; color: $text; margin: 0; }

// Buttons
.btn-amz {
  display: inline-flex; align-items: center; gap: 8px; padding: 9px 20px; border-radius: $radius-sm; border: none;
  font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13px; font-weight: 600; cursor: pointer; transition: all 0.2s ease;
  &--primary { background: $primary; color: white; &:hover { background: $primary-dark; } }
  &--ghost { background: transparent; color: $text-muted; border: 1px solid $border; &:hover { background: $bg; color: $text; } }
}

// KPI
.kpi-strip { display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px; margin-bottom: 20px; max-width: 400px; }
.kpi-card { background: $card-bg; border: 1px solid $border; border-radius: $radius-sm; padding: 16px 18px; display: flex; flex-direction: column; box-shadow: $shadow; }
.kpi-label { font-family: 'JetBrains Mono', monospace; font-size: 10px; font-weight: 600; letter-spacing: 1px; text-transform: uppercase; color: $text-muted; }
.kpi-value { font-family: 'JetBrains Mono', monospace; font-size: 22px; font-weight: 700; color: $text; font-feature-settings: "tnum"; margin: 4px 0 2px; }
.kpi-foot { font-family: 'JetBrains Mono', monospace; font-size: 10px; color: $text-muted; }

// Form
.form-card {
  background: $card-bg; border: 1px solid $border; border-radius: $radius; box-shadow: $shadow; margin-bottom: 20px; overflow: hidden;
  &__header { display: flex; align-items: center; gap: 14px; padding: 22px 24px 0; }
  &__icon { width: 42px; height: 42px; border-radius: 10px; display: flex; align-items: center; justify-content: center; font-size: 16px; background: rgba($primary, 0.1); color: $primary; flex-shrink: 0; }
  &__title { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 16px; font-weight: 700; color: $text; margin: 0; }
  &__footer { display: flex; justify-content: flex-end; gap: 8px; padding: 0 24px 20px; }
}

.form-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 14px; padding: 20px 24px; }

.field {
  display: flex; flex-direction: column; gap: 5px;
  &__label { font-family: 'JetBrains Mono', monospace; font-size: 10px; font-weight: 600; letter-spacing: 0.5px; text-transform: uppercase; color: $text-muted; margin: 0; }
  &__input { border-radius: 8px !important; border: 1px solid $border !important; font-size: 13px !important; &:focus { border-color: $primary !important; box-shadow: 0 0 0 3px rgba($primary, 0.1) !important; } }
}

// List
.list-card {
  background: $card-bg; border: 1px solid $border; border-radius: $radius; box-shadow: $shadow; overflow: hidden;
  &__header { display: flex; justify-content: space-between; align-items: center; padding: 18px 22px; border-bottom: 1px solid $border; }
  &__title { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 16px; font-weight: 700; color: $text; margin: 0; }
  &__footer { padding: 12px 22px; border-top: 1px solid $border; }
}

.search-box {
  position: relative; width: 240px;
  &__icon { position: absolute; left: 10px; top: 50%; transform: translateY(-50%); color: $text-muted; font-size: 12px; }
  &__input { width: 100%; padding: 7px 12px 7px 32px; border: 1px solid $border; border-radius: $radius-sm; font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13px; color: $text; background: transparent; &::placeholder { color: #CBD5E1; } &:focus { outline: none; border-color: $primary; } }
}

.table-wrapper { padding: 0; }

// Los ::v-deep van bajo .amz-page a proposito: en la raiz, postcss-rtl + scoped generan [dir][data-v-xxx]
// y ninguna propiedad direccional (padding, margin...) llega a aplicarse.
.amz-page ::v-deep .table-head th { font-family: 'JetBrains Mono', monospace; font-size: 10px; font-weight: 600; letter-spacing: 1px; text-transform: uppercase; color: $text-muted; border-top: none; border-bottom: 1px solid $border; padding: 10px 16px; background: transparent; }
.amz-page ::v-deep .table-row td { padding: 10px 16px; vertical-align: middle; border-color: lighten($border, 3%); font-size: 13px; }
.amz-page ::v-deep .table-row:hover td { background: $bg; }

.cell-sku { font-family: 'JetBrains Mono', monospace; font-size: 12px; font-weight: 500; color: $text; &--accent { color: $primary; font-weight: 600; } }
.cell-mono { font-family: 'JetBrains Mono', monospace; font-size: 12px; color: $text; font-feature-settings: "tnum"; }
.cell-muted { color: #CBD5E1; font-size: 12px; }

.cell-actions { display: flex; gap: 4px; }
.action-btn {
  width: 30px; height: 30px; border-radius: 6px; border: 1px solid transparent; background: transparent; color: $text-muted; cursor: pointer;
  display: flex; align-items: center; justify-content: center; transition: all 0.15s ease; font-size: 12px;
  &--edit:hover { background: rgba($primary, 0.1); color: $primary; border-color: rgba($primary, 0.2); }
  &--delete:hover { background: rgba($danger, 0.1); color: $danger; border-color: rgba($danger, 0.2); }
}

.footer-count { font-family: 'JetBrains Mono', monospace; font-size: 12px; color: $text-muted; }

// Slide
.slide-enter-active, .slide-leave-active { transition: all 0.3s ease; max-height: 400px; overflow: hidden; }
.slide-enter, .slide-leave-to { max-height: 0; opacity: 0; margin-bottom: 0; }

// Responsive
@media (max-width: 768px) {
  .form-grid { grid-template-columns: 1fr 1fr; }
  .amz-header { flex-direction: column; align-items: flex-start; gap: 12px; }
  .search-box { width: 100%; }
}
</style>

<style lang="scss">
// Modal
.modal-amz {
  .modal-content { border-radius: 16px; border: 1px solid #E2E8F0; box-shadow: 0 20px 60px rgba(0,0,0,0.12), 0 8px 20px rgba(0,0,0,0.06); overflow: hidden; }
  .modal-body { padding: 0; }
}

.modal-inner { padding: 0; }
.modal-hdr {
  text-align: center; padding: 28px 28px 0;
  &__icon { width: 48px; height: 48px; border-radius: 12px; display: inline-flex; align-items: center; justify-content: center; margin-bottom: 14px; font-size: 18px; background: rgba(#3B82F6, 0.1); color: #3B82F6; }
  &__title { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 18px; font-weight: 700; color: #1E293B; margin: 0 0 4px; }
  &__sub { font-family: 'JetBrains Mono', monospace; font-size: 12px; color: #64748B; margin: 0; }
}
.modal-body-custom { padding: 22px 28px; }
.modal-ftr { display: flex; justify-content: flex-end; gap: 8px; padding: 0 28px 24px; }

.btn-modal {
  display: inline-flex; align-items: center; gap: 6px; padding: 9px 18px; border-radius: 8px; border: none;
  font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13px; font-weight: 600; cursor: pointer; transition: all 0.15s ease;
  &--primary { background: #3B82F6; color: white; &:hover { background: #2563EB; } }
  &--ghost { background: transparent; color: #64748B; &:hover { background: #F1F5F9; color: #1E293B; } }
}

// Dark mode
.dark-layout {
  .amz-page {
    .header-title { color: #E2E8F0; }
    .kpi-card { background: #1E293B; border-color: #334155; }
    .kpi-value { color: #F1F5F9; }
    .form-card { background: #1E293B; border-color: #334155; }
    .form-card__title { color: #E2E8F0; }
    .field__label { color: #94A3B8; }
    .field__input { background: #0F172A !important; border-color: #334155 !important; color: #E2E8F0 !important; &:focus { border-color: #3B82F6 !important; } }
    .list-card { background: #1E293B; border-color: #334155; }
    .list-card__header { border-color: #334155; }
    .list-card__title { color: #E2E8F0; }
    .list-card__footer { border-color: #334155; }
    .search-box__input { border-color: #334155; color: #E2E8F0; &::placeholder { color: #475569; } &:focus { border-color: #3B82F6; } }
    .table-head th { color: #94A3B8; border-color: #334155; }
    .table-row td { border-color: #334155; }
    .table-row:hover td { background: rgba(255,255,255,0.03); }
    .cell-sku { color: #E2E8F0; }
    .cell-mono { color: #E2E8F0; }
    .action-btn { color: #94A3B8; }
    .btn-amz--ghost { border-color: #475569; color: #94A3B8; &:hover { background: #334155; color: #E2E8F0; } }
  }
  .modal-amz .modal-content { background: #1E293B; border-color: #334155; }
  .modal-hdr__title { color: #E2E8F0; }
}
</style>
